module.exports = __webpack_public_path__ + "static/media/dummy-profile-picture.faeec362.png";